var map = {
	"./about-page-large.webp": 941,
	"./about-page-medium.webp": 585,
	"./about-page-preview.webp": 518,
	"./about-page-small.webp": 609,
	"./main-page-large.webp": 773,
	"./main-page-medium.webp": 761,
	"./main-page-preview.webp": 985,
	"./main-page-small.webp": 417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 468;